import React from 'react'
import { useAppRole } from '../hooks/useAppRole'
import { rbacStrings } from '../i18n/rbacStrings'
import { Capability } from '../types/rbac.types'

export interface RequireCapabilityProps {
  capability: Capability
  children: React.ReactNode
}

const messageStyle: React.CSSProperties = {
  padding: '2rem 0',
  fontSize: 14,
  color: '#6b7280',
}

// Garde de page : n'affiche le contenu que si la capacité est accordée par le
// serveur. Fail-closed pendant le chargement et en cas d'indisponibilité.
export default function RequireCapability({ capability, children }: RequireCapabilityProps) {
  const { capabilities, isResolved, isLoading } = useAppRole()

  if (capabilities.has(capability)) return <>{children}</>

  let message = rbacStrings.pageNotAllowed
  if (isLoading) message = rbacStrings.loading
  else if (!isResolved) message = rbacStrings.unavailable

  return <div style={messageStyle}>{message}</div>
}
